const EXACT_FRACTIONAL_DIGITS_NUMBER = 2;

const NUMBER_FORMAT_OPTIONS = {
  minimumFractionDigits: EXACT_FRACTIONAL_DIGITS_NUMBER,
  maximumFractionDigits: EXACT_FRACTIONAL_DIGITS_NUMBER,
};

export const formatPercents = (value: number) => {
  return new Intl.NumberFormat('US-en', {
    style: 'percent',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  }).format(value / 100);
};

export const formatUSDollarsWithCents = (amount: number) => {
  return new Intl.NumberFormat('US-en', {
    ...NUMBER_FORMAT_OPTIONS,
    style: 'currency',
    currencyDisplay: 'narrowSymbol',
    currency: 'USD',
  }).format(amount);
};
